<template>
    <b-modal id="medicineDetailModal" :title="title" size="md">
        <div class="search user_modal">
            <div class="table_list">
                <div class="detail">
                    <div class="title_sm pt0">
                        <h3 class="tb_title">{{medicineData.med_hrb_nm}}</h3>
                    </div>
                    <table class="write">
                        <colgroup>
                            <col width="100">
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>약재명</th>
                                <td><span>{{medicineData.med_hrb_nm}}</span></td>
                            </tr>
                            <tr>
                                <th>설명</th>
                                <td><span>{{medicineData.med_prfm}}</span></td>
                            </tr>
                            <tr>
                                <th>이명</th>
                                <td><span>{{medicineData.med_alias}}</span></td>
                            </tr>
                            <tr v-if="medicineData.companyName != null && medicineData.companyName != ''">
                                <th>제약회사</th>
                                <td><span>{{medicineData.companyName}}</span></td>
                            </tr>
                            <tr>
                                <th>성미</th>
                                <td><span>{{medicineData.property_taste}}</span></td>
                            </tr>
                            <tr>
                                <th>귀경</th>
                                <td><span>{{medicineData.meridian_tropism}}</span></td>
                            </tr>
                            <tr>
                                <th>사상</th>
                                <td><span>{{medicineData.sasang_type}}</span></td>
                            </tr>
                            <tr>
                                <th>학명</th>
                                <td><span>{{medicineData.scientific_name}}</span></td>
                            </tr>
                            <tr>
                                <th>효과효능</th>
                                <td><span>{{medicineData.efficacy_effect}}</span></td>
                            </tr>
                            <tr>
                                <th>주의사항</th>
                                <td><span>{{medicineData.precautions}}</span></td>
                            </tr>
                            <tr>
                                <th>참고사항</th>
                                <td><span>{{medicineData.additional_info}}</span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <template #modal-footer="{ ok }">
            <b-button @click="fn_click_apply()" class="btn btn_md btn_brown">반영</b-button>
            <b-button @click="ok" class="btn btn_md btn_brown">닫기</b-button>
        </template>
    </b-modal>

</template>

<script>
    export default {
        name: 'medicineDetailModal',
        props: {
            title: String,
            medicineData : {
                med_hrb_nm : '',
                med_prfm : '',
                companyName : ''
            }
        },
        methods: {
            fn_click_apply(){
                this.$emit('callback', this.medicineData);
            }          
        },
        data () {
            return {
            }
        }
    }
</script>

<style>

</style>